module.exports = __webpack_public_path__ + "img/liste_deroulante.dcbc672b.png";